export const TRANSACTION_ID = 'lohi_pay_transaction_id';
export const MERCHANT_ID = 'lohi_pay_merchant_id';
export const SETTLEMENT_ID = 'lohi_pay_settlement_id';
